import React,{useRef,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: 'fixed',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
      },
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
  
    marginBottom: 50,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function OrderedProductReview(props) {
    const classes = useStyles();
    const [products,setProducts] = useState(generateSampleProductData());


    function orderValue(unit){
      return unit.order_quantity <= 0 ? '':unit.order_quantity
    }

    function orderInput(product,unit){
        return(
          <Box display="flex" justifyContent="flex-end" >
            <Box p={1} display="flex" justifyContent="center"  flexDirection="column">
              <Typography variant="h6" component="span" style={{ fontWeight:600,fontSize:"16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
            </Box>
            <Box p={1} style={{maxWidth:"100px"}}>
            <TextField
              id="outlined-size-small"
              variant="outlined"
              size="small"
              type="number"
              value = {orderValue(unit)}
            />
            </Box>
            
          </Box>
        )
      }
    function productElement(product){
        return (
          <Grid container style={{padding:"0px"}}>
            <Grid container item xs={12} >
              < Grid item xs={3} md={2} lg={1} style={{padding:"4px"}} container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center">
                <img src={product.image} style={{ width:"100%"}} />
              </Grid>
              <Grid item xs={9} md={10} lg={11}>
                <Grid 
                container
                direction="column"
                justifyContent="space-between"
                alignItems="stretch">
                    <Grid item >
                      <Box style={{ fontWeight:600,fontSize:"14px" }}>{product.brand}</Box>
                      <Box  style={{ fontWeight:600,fontSize:"14px" }}>{product.name}</Box>
      
                    </Grid>
                    <Grid item >
                      {
                        product.units.map(unit=>(
                            <React.Fragment key={unit.id} >
                           {orderInput(product,unit)}
                            </React.Fragment>
                          )
                        )
                      }
                      
                       
                    </Grid>
                    <Grid item style={{ fontWeight:600,fontSize:"14px",color:"red"}}>Available: {product.available_inventory} {product.available_inventory_unit}</Grid>
                  <Grid item style={{ fontWeight:600,fontSize:"14px",color:"green"}}>Total : P {product.total_order_value}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
    function productLists(){
        return(
          <List>
            {
              products.map(product=>(
                <React.Fragment key={product.id}>
                  <ListItem >
                    {productElement(product)}
                  </ListItem>
                  <Divider light />
                  </React.Fragment>
                )
              )
            }
          </List>
        )
      }
     
    function generateSampleProductData(){

        var products = [];
        
        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/16a69e55a1078c38235689831c257f81.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Coca-Cola Light Taste 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Coca-Cola Zero Sugar1.5L`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 600
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 12;
            unit.price_with_tax = y== 0 ? 60 : 720;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 10

            units.push(unit)
        }
        product.units = units;
        products.push(product)

        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/e231144bf1e0825fb5927cdb6b95203b.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Royal Tru-Lemon 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Coca-Cola Original Taste1.5L`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 300
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 12;
            unit.price_with_tax = y== 0 ? 60 : 720;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 5

            units.push(unit)
        }
        product.units = units;
        products.push(product)


        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/cedd42d75fe93f0533fc488e8ec8389c.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Coca-Cola Original Taste 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Coca-Cola Original Taste 325mL`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 648
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 24;
            unit.price_with_tax = y== 0 ? 27 : 648;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 24

            units.push(unit)
        }
        product.units = units;
        products.push(product)



        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/84cba2e67cad58be94a46c073b5dbd09.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Coca-Cola Zero Sugar 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Wilkins Distilled 7L`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 850
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 3;
            unit.price_with_tax = y== 0 ? 85 : 255;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 10

            units.push(unit)
        }
        product.units = units;
        products.push(product)



        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/16a69e55a1078c38235689831c257f81.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Coca-Cola Light Taste 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Wilkins Distilled w/ Deposit 5G w/ Deposit`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 2100
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 3;
            unit.price_with_tax = y== 0 ? 420 : 1260;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 5

            units.push(unit)
        }
        product.units = units;
        products.push(product)


        var product = {};
        product.image = 'https://ph-live-05.slatic.net/p/e231144bf1e0825fb5927cdb6b95203b.jpg_720x720q80.jpg_.webp'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Royal Tru-Lemon 325mL`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Wilkins Pure 500mL x 24`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 220
        product.available_inventory = 1000
        product.available_inventory_unit= 'bottle'
        var units = [];
        for(var y =0 ; y <1;y++){
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest = y == 0 ? 1 : 24;
            unit.price_with_tax = y== 0 ? 22 : 264;
            unit.price_without_tax = 10.00;
            unit.order_quantity = 10

            units.push(unit)
        }
        product.units = units;
        products.push(product)
  
        return products;
  
    }
    function addToInvoiceClickEvent(){
        alert();
    }
    return (
      <div>
         <Dialog fullScreen open={props.openOrderedProductsReview} onClose={()=>{props.setOpenOrderedProductsReview(false)}} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
              <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={()=>{props.setOpenOrderedProductsReview(false)}}
                    aria-label="close"
                    size="large">
                  <CloseIcon />
                  </IconButton>
                  <Typography variant="subtitle1" className={classes.title}>
                    Order Review
                  </Typography>
              </Toolbar>
          </AppBar>
          <div className={classes.appBarSpacer}></div>
          <Paper square className={classes.productListPaper}>
             
              {productLists()}
          </Paper>
          <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
          <Toolbar>
          <Typography variant="subtitle1" noWrap>
                      Total : 4,718.00
          </Typography>
          <div className={classes.grow} />
          
          <Button variant="contained" onClick={()=>{props.setOpenDeliveryPickupAndPaymentDialog(true)}}>
          <Typography variant="caption" noWrap>
          Finalize products
          </Typography>

              <Badge badgeContent={6} color="secondary" style={{marginLeft:"1rem"}}/>
          </Button>
          
          </Toolbar>
      </AppBar>
    </Dialog>
         
         
      </div>
    );
}

export default OrderedProductReview